import script from "./FaqPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqPicker.vue?vue&type=script&setup=true&lang=js"

import "./FaqPicker.vue?vue&type=style&index=0&id=44f2fd8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f2fd8e"]])

export default __exports__